module.exports = __webpack_public_path__ + "img/1-5.b1a53d06.png";